import Splide from '@splidejs/splide';
import debounce from 'lodash/debounce';

export const initNewStandardCarousel = () => {
  const { GoogleAnalytics } = window;
  const standardSliderEl = document.querySelector(
    '[data-pro-single-family-new-standart-slider]'
  );

  const standardSlider = new Splide(standardSliderEl, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 500,
    autoplay: true,
    interval: 5000,
    rewind: true,
    rewindSpeed: 500,
    arrows: true,
    pagination: false,
    autoHeight: true,
  });

  standardSlider.mount();
  standardSlider.event.on('move', () => {
    const { Autoplay } = standardSlider.Components;

    if (Autoplay.isPaused()) {
      GoogleAnalytics.trackEvent(
        'For Pros - Single Family',
        'Click',
        'New Standards'
      );
    }
  });

  // NOTE: Made arrows in the center of the slide
  const sliderArrowEl = document.querySelector(
    '[data-pro-single-family-new-standart-slider-arrows]'
  );
  const slideContentEl = document.querySelector(
    '[data-pro-single-family-new-standart-slide-content]'
  );
  const mediumWindowWidth = 1024;

  function madeArrowInCenter() {
    if (window.innerWidth <= mediumWindowWidth) {
      sliderArrowEl.style.top = `${slideContentEl.offsetTop}px`;
    } else {
      sliderArrowEl.style.top = '50%';
    }
  }
  madeArrowInCenter();

  standardSlider.event.on(
    'resize',
    debounce(() => {
      madeArrowInCenter();
    }, 200)
  );
};
